import type { ActionDrawerState, DrilldownPayload, PrimaryCTA, SecondaryCTA } from '../../core'

/**
 * A chart-bar drilldown's context carries which block it targets (see BarchartBlock /
 * DoubleBarChartBlock), since either CTA could in principle open the same drawer. Match that
 * against `primary_cta.block`; anything else is assumed to be the secondary CTA's block.
 */
export const getCtaForChartBarClick = (
  actionDrawer: ActionDrawerState,
  primary_cta: PrimaryCTA | undefined,
  secondary_cta: SecondaryCTA | undefined,
): PrimaryCTA | SecondaryCTA | undefined => {
  const context = actionDrawer.context as DrilldownPayload | undefined
  const blockName = context?.block

  if (blockName === primary_cta?.block) {
    return primary_cta
  }
  return secondary_cta
}

/**
 * Resolves which CTA (primary/secondary) drives the currently open drawer's title/variant, based
 * on what triggered it. Falls back to `primary_cta` whenever resolution comes up empty (e.g. a
 * `secondaryCta` trigger with no configured secondary CTA), so callers never have to null-check.
 */
export const getDynamicCtaBasedOnTriggers = (
  actionDrawer: ActionDrawerState,
  primary_cta: PrimaryCTA | undefined,
  secondary_cta: SecondaryCTA | undefined,
): PrimaryCTA | SecondaryCTA | undefined => {
  if (actionDrawer.trigger === 'secondaryCta') {
    return secondary_cta ?? primary_cta
  }
  if (actionDrawer.trigger === 'primaryCta') {
    return primary_cta
  }
  return getCtaForChartBarClick(actionDrawer, primary_cta, secondary_cta) ?? primary_cta
}
